<template>
  <div class="q-pa-md q-gutter-sm">
    <q-btn
      label="Filtros"
      no-caps
      icon="filter_alt"
      color="primary"
      @click="abrirModal = true"
    />

    <q-dialog
      v-model="abrirModal"
      :persistent="persistent"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 700px">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">Selecione os Filtros</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            Depois de selecionado, click em 'ok' para carregar os dados.
          </q-card-section>
        </div>

        <div class="row text-brand-5 text-weight-bold">
          <span style="width: 48%" class="col-2 q-ml-sm q-mt-sm"
            >Data Inicial</span
          >
          <span style="width: 44%" class="col-2 q-ml-sm q-mt-sm"
            >Data Final</span
          >
        </div>

        <div class="row col col-3 q-px-sm">
          <q-input
            style="width: 49%"
            class="col input"
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.data.from"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    :options="optionsFn"
                    mask="DD/MM/YYYY"
                    v-model="filtros.data"
                    range
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <q-input
            class="col q-ml-sm input"
            style="width: 49%"
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.data.to"
            mask="##/##/####"
          />
        </div>

        <div
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="texto-titulo-input">Unidade Origem</div>
            <q-select
              dense
              outlined
              option-label="label"
              option-value="id"
              v-model="filtros.unidadeOrigem"
              :options="optionsUnidade"
              label="Unidade Origem"
              label-color="grey-6"
            />
          </div>
          <div class="col">
            <div class="texto-titulo-input">Unidade Destino</div>
            <q-select
              dense
              outlined
              option-label="label"
              option-value="id"
              v-model="filtros.unidadeDestino"
              :options="optionsUnidade"
              label="Unidade Destino"
              label-color="grey-6"
            />
          </div>
        </div>

        <div
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="texto-titulo-input">Numero Requisição</div>
            <q-input v-model="filtros.numeroRequisicao" dense outlined />
          </div>
          <div class="col">
            <div class="texto-titulo-input">Numero Picking</div>
            <q-input v-model="filtros.numeroPicking" dense outlined />
          </div>
        </div>

        <div
          class="row q-gutter-sm q-px-sm q-mt-xs q-mb-sm text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="texto-titulo-input">Produto</div>
            <q-input
              dense
              outlined
              v-model="filtros.produto"
              placeholder="Código ou descrição"
            />
          </div>
        </div>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn
            label="Filtrar"
            :loading="loading"
            no-caps
            icon="filter_alt"
            dense
            color="primary"
            @click="emitirFiltros"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "ModalRelatorioPicking",
  emits: ["filtrar"],
  props: {
    loadingValue: {
      default: "",
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const abrirModal = ref(false);
    const persistent = ref(false);
    const loading = ref(false);
    const optionsUnidade = ref([]);

    const filtros = ref({
      data: { from: "", to: "" },
      unidadeOrigem: null,
      unidadeDestino: null,
      numeroRequisicao: "",
      numeroPicking: "",
      produto: "",
    });

    const emitirFiltros = () => {
      persistent.value = true;
      loading.value = true;

      let dataFrom = filtros.value.data.from;
      let dataTo = filtros.value.data.to;

      if (!dataFrom || !dataTo) {
        const hoje = new Date();
        const quinzeDiasAtras = new Date(hoje.getTime());
        quinzeDiasAtras.setDate(hoje.getDate() - 15);

        const formatarData = (d) =>
          d
            .toLocaleDateString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .reverse()
            .join("-");

        dataFrom = dataFrom
          ? dataFrom.split("/").reverse().join("-")
          : formatarData(quinzeDiasAtras);
        dataTo = dataTo
          ? dataTo.split("/").reverse().join("-")
          : formatarData(hoje);
      } else {
        dataFrom = dataFrom.split("/").reverse().join("-");
        dataTo = dataTo.split("/").reverse().join("-");
      }

      emit("filtrar", {
        dataInicial: dataFrom,
        dataFinal: dataTo,
        unidadeOrigemId: filtros.value.unidadeOrigem?.id || undefined,
        unidadeDestinoId: filtros.value.unidadeDestino?.id || undefined,
        numeroRequisicao: filtros.value.numeroRequisicao || undefined,
        numeroPicking: filtros.value.numeroPicking || undefined,
        produto: filtros.value.produto || undefined,
      });

      filtros.value.data = { from: "", to: "" };
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        const array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            label: unidade.nome,
            id: unidade.id,
          });
        });
        optionsUnidade.value.unshift({ label: "Todas", id: null });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => props.loadingValue,
      () => {
        loading.value = props.loadingValue;
        if (loading.value == false) {
          setTimeout(() => {
            abrirModal.value = false;
            persistent.value = false;
          }, 1000);
        }
      }
    );

    onMounted(listarUnidades);
    onMounted(() => {
      abrirModal.value = true;
    });

    return {
      abrirModal,
      persistent,
      loading,
      filtros,
      optionsUnidade,
      emitirFiltros,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      optionsFn(date) {
        const hoje = new Date();
        const dd = String(hoje.getDate()).padStart(2, "0");
        const mm = String(hoje.getMonth() + 1).padStart(2, "0");
        const yyyy = hoje.getFullYear();
        return date <= `${yyyy}/${mm}/${dd}`;
      },
    };
  },
};
</script>
